import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { generateStorageBlobUrl } from '@utils/generateAssetLinks';
import { Logo } from '../shared';
import { BLOB_TYPES, UNAVAILABLE_CS_FIRM } from '@constants';
import { useSlideData } from '@context/slide-data';

const IntroStyle = styled.div`
    background: ${({url}) => `url(${url}) no-repeat center`};
    background-size: cover;
    height: 100%;
    width: 100%;
    color: rgba(5, 5, 5, 0.4);
    font-size: 1.25rem;
    font-family: ${props => props.theme.sansSerif};
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    >div {
        position: relative;
        left: 7%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 45%;
        top: 5%;
        color: white;
    }
`;

// To-do: shift media queries over props
const IntroText = styled.div`
    font-size: 18px;
    width: 100%;
    overflow-x: hidden;
    h2 {
        font-family: ${props => props.theme.serif};
        padding-bottom: 9px;
        border-bottom: 1px solid #fff;
        font-size: ${props => props.mobile ? '32px': '40px'};
        margin-bottom: 3px;
    }
`;

export const Introduction = () => {
    const { t } = useTranslation();
    const { firstName, lastName, firmShortName } = useClient();
    const { desktop, mobile } = useSlideData();
    const backgroundUrl = generateStorageBlobUrl(BLOB_TYPES.background, firmShortName);

    if (firmShortName === UNAVAILABLE_CS_FIRM) {
        return <div>Information not available.</div>
    }

    return (
        <IntroStyle url={backgroundUrl} desktop={desktop}>
            <div>
                <IntroText mobile={mobile}>
                    <span style={{ textTransform: 'uppercase' }}>{t('introduction.text')}:</span>
                    <h2>{firstName} {lastName}</h2>
                    <span>{moment().format('dddd') + ', ' + moment().format('MMMM Do YYYY')}</span>
                </IntroText>
                <Logo view='intro' />
            </div>
        </IntroStyle>
    );
};

export default Introduction;
